
<template>
    <form @submit.prevent="search" class="header__search-form no-margin">
        <FormInput
            v-model="keywords"
            class="header__search"
            :hideLabel="true"
            label="How do I help patients with..."
            id="search"
            placeholder="How do I help patients with..."
            aria-label="Search, for example - How do I help patients with..."
            type="text"
        >
            <button class="btn--search" type="submit"><SVGicon-search /></button>
        </FormInput>
    </form>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    data() {
        return {
            keywords: null
        }
    },

    mounted () {
        const { name, query } = this.$route
        if (name == 'results' && query && query.keywords) {
            this.keywords = query.keywords
            this.submitSearch(decodeURIComponent(query.keywords))
        }
    },

    methods: {
        ...mapActions('Resources', ['submitSearch']),

        search () {
            if (this.$route.name !== 'results') {
                this.$router.push({ name: 'results', query: { keywords: encodeURIComponent(this.keywords) } })
            } else {
                this.$router.replace({ name: 'results', query: { keywords: encodeURIComponent(this.keywords) }})
            }

            this.$emit('closeMobNav')
            this.submitSearch(this.keywords)
        }
    }
}
</script>
